import { Component, Input } from '@angular/core';

@Component({
  selector: 'success-f-modal-page',
  templateUrl: './success-f-modal.component.html'
})
export class FrontSuccessModalComponent {

  @Input() data;

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/modules/frontend/login/success-f-modal.component.ts